import { FC } from 'react'

import { Text } from '@revolut-internal/ui-kit'

import { BreachCell } from 'modules/Monitoring/components/TableCells/BreachCell'
import { CountMetric } from 'modules/Monitoring/types'
import { formatNumber } from 'modules/Monitoring/utils/formatNumber'
import { pluralize } from 'modules/Monitoring/utils/pluralize'

type CountCellProps = {
  metric: CountMetric | null
  entityName: string
  isGrouped: boolean
}

export const CountCell: FC<CountCellProps> = ({ metric, entityName, isGrouped }) => {
  if (!metric) {
    return <Text color="grey-tone-20">-</Text>
  }

  const formattedValue = isGrouped
    ? `${formatNumber(metric.value)} ${pluralize(entityName, metric.value, true)}`
    : formatNumber(metric.value)

  return <BreachCell slaBreach={metric.slaBreach}>{formattedValue}</BreachCell>
}
